import { __awaiter, __generator } from "tslib";
import { Component, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { EventViewMode, Properties, } from './../services/definitions.service';
import { AddEventComponent } from './dialogs/add-event/add-event.component';
import 'firebase/firestore';
import { FormControl } from '@angular/forms';
import { groupBy } from 'lodash';
import { EventState } from '../testing/mock-common-functions.service';
import * as i0 from "@angular/core";
import * as i1 from "../services/data-model.service";
import * as i2 from "../services/common-functions.service";
import * as i3 from "../services/log.service";
import * as i4 from "@angular/material/dialog";
import * as i5 from "ngx-device-detector";
import * as i6 from "../services/auth.service";
import * as i7 from "@angular/material/form-field";
import * as i8 from "@angular/material/select";
import * as i9 from "@angular/common";
import * as i10 from "@angular/material/tabs";
import * as i11 from "@angular/forms";
import * as i12 from "@angular/material/core";
import * as i13 from "./components/event-view/event-view.component";
import * as i14 from "@angular/material/slide-toggle";
import * as i15 from "@angular/material/tooltip";
import * as i16 from "@angular/material/card";
import * as i17 from "@angular/material/table";
import * as i18 from "@angular/material/button";
import * as i19 from "@angular/material/icon";
function EventsAdminComponent_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var option_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r12.value);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", option_r12.label, " ");
} }
function EventsAdminComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Aktiv ");
} }
function EventsAdminComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    var _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "event-view", 17);
    i0.ɵɵlistener("componentChanged", function EventsAdminComponent_div_10_Template_event_view_componentChanged_1_listener($event) { i0.ɵɵrestoreView(_r16); var ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.eventChanged($event); })("componentLoaded", function EventsAdminComponent_div_10_Template_event_view_componentLoaded_1_listener($event) { i0.ɵɵrestoreView(_r16); var ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.subComponentIsLoaded($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var data_r13 = ctx.$implicit;
    var ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", data_r13)("users", ctx_r2.users)("userOptions", ctx_r2.userOptions)("accountingYear", ctx_r2.accountingYear)("viewMode", ctx_r2.viewMode)("collapsed", true);
} }
function EventsAdminComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Keine Events vorhanden");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Beendet ");
} }
function EventsAdminComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    var _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "event-view", 17);
    i0.ɵɵlistener("componentChanged", function EventsAdminComponent_div_14_Template_event_view_componentChanged_1_listener($event) { i0.ɵɵrestoreView(_r21); var ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.eventChanged($event); })("componentLoaded", function EventsAdminComponent_div_14_Template_event_view_componentLoaded_1_listener($event) { i0.ɵɵrestoreView(_r21); var ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.subComponentIsLoaded($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var data_r18 = ctx.$implicit;
    var ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", data_r18)("users", ctx_r5.users)("userOptions", ctx_r5.userOptions)("accountingYear", ctx_r5.accountingYear)("viewMode", ctx_r5.viewMode)("collapsed", true);
} }
function EventsAdminComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2, "Keine Events vorhanden");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Schicht-\u00DCbersicht ");
} }
function EventsAdminComponent_mat_option_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var event_r23 = ctx.$implicit;
    var ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", event_r23.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", event_r23.name, " ", ctx_r8.shiftIsPassed(event_r23) ? "(beendet)" : "", " ");
} }
function EventsAdminComponent_mat_slide_toggle_24_Template(rf, ctx) { if (rf & 1) {
    var _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-slide-toggle", 19);
    i0.ɵɵlistener("change", function EventsAdminComponent_mat_slide_toggle_24_Template_mat_slide_toggle_change_0_listener($event) { i0.ɵɵrestoreView(_r25); var ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.onChangeShowNames($event); });
    i0.ɵɵtext(1, "Namen ausblenden");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("checked", ctx_r9.showNames);
} }
function EventsAdminComponent_div_26_div_6_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Schicht-Name ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_26_div_6_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵelementStart(1, "b");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r42 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", shift_r42.type, " ");
} }
function EventsAdminComponent_div_26_div_6_mat_header_cell_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Schichtleiter ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_26_div_6_mat_cell_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r43 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", shift_r43.responsiblePerson, " ");
} }
function EventsAdminComponent_div_26_div_6_mat_header_cell_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Start ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_26_div_6_mat_cell_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r44 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, shift_r44.start.toDate(), "HH:mm"), " Uhr ");
} }
function EventsAdminComponent_div_26_div_6_mat_header_cell_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Ende ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_26_div_6_mat_cell_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r45 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, shift_r45.end.toDate(), "HH:mm"), " Uhr ");
} }
function EventsAdminComponent_div_26_div_6_mat_header_cell_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Freie Pl\u00E4tze ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_26_div_6_mat_cell_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r46 = ctx.$implicit;
    var ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r37.calcFreePlaces(shift_r46), " ");
} }
function EventsAdminComponent_div_26_div_6_mat_header_cell_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell");
    i0.ɵɵtext(1, " Teilnehmer ");
    i0.ɵɵelementEnd();
} }
function EventsAdminComponent_div_26_div_6_mat_cell_21_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var idx_r50 = i0.ɵɵnextContext().index;
    var shift_r47 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", shift_r47.participants && shift_r47.participants[idx_r50] ? shift_r47.participants[idx_r50].firstName + " " + shift_r47.participants[idx_r50].lastName : "Nicht belegt", " ");
} }
var _c0 = function (a0, a1) { return { occupied: a0, empty: a1 }; };
function EventsAdminComponent_div_26_div_6_mat_cell_21_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, EventsAdminComponent_div_26_div_6_mat_cell_21_div_2_div_1_Template, 2, 1, "div", 38);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var idx_r50 = ctx.index;
    var shift_r47 = i0.ɵɵnextContext().$implicit;
    var ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0, shift_r47.participants && shift_r47.participants[idx_r50], !(shift_r47.participants && shift_r47.participants[idx_r50])));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r48.hideNames);
} }
var _c1 = function () { return []; };
function EventsAdminComponent_div_26_div_6_mat_cell_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell");
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵtemplate(2, EventsAdminComponent_div_26_div_6_mat_cell_21_div_2_Template, 2, 5, "div", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var shift_r47 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(shift_r47.minParticipants));
} }
function EventsAdminComponent_div_26_div_6_mat_header_row_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function EventsAdminComponent_div_26_div_6_mat_row_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row");
} }
var _c2 = function () { return ["name", "responsiblePerson", "start", "end", "freePlaces", "participants"]; };
function EventsAdminComponent_div_26_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table", 24);
    i0.ɵɵelementContainerStart(4, 25);
    i0.ɵɵtemplate(5, EventsAdminComponent_div_26_div_6_mat_header_cell_5_Template, 2, 0, "mat-header-cell", 26);
    i0.ɵɵtemplate(6, EventsAdminComponent_div_26_div_6_mat_cell_6_Template, 3, 1, "mat-cell", 27);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 28);
    i0.ɵɵtemplate(8, EventsAdminComponent_div_26_div_6_mat_header_cell_8_Template, 2, 0, "mat-header-cell", 26);
    i0.ɵɵtemplate(9, EventsAdminComponent_div_26_div_6_mat_cell_9_Template, 2, 1, "mat-cell", 27);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 29);
    i0.ɵɵtemplate(11, EventsAdminComponent_div_26_div_6_mat_header_cell_11_Template, 2, 0, "mat-header-cell", 26);
    i0.ɵɵtemplate(12, EventsAdminComponent_div_26_div_6_mat_cell_12_Template, 3, 4, "mat-cell", 27);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 30);
    i0.ɵɵtemplate(14, EventsAdminComponent_div_26_div_6_mat_header_cell_14_Template, 2, 0, "mat-header-cell", 26);
    i0.ɵɵtemplate(15, EventsAdminComponent_div_26_div_6_mat_cell_15_Template, 3, 4, "mat-cell", 27);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(16, 31);
    i0.ɵɵtemplate(17, EventsAdminComponent_div_26_div_6_mat_header_cell_17_Template, 2, 0, "mat-header-cell", 26);
    i0.ɵɵtemplate(18, EventsAdminComponent_div_26_div_6_mat_cell_18_Template, 2, 1, "mat-cell", 27);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(19, 32);
    i0.ɵɵtemplate(20, EventsAdminComponent_div_26_div_6_mat_header_cell_20_Template, 2, 0, "mat-header-cell", 26);
    i0.ɵɵtemplate(21, EventsAdminComponent_div_26_div_6_mat_cell_21_Template, 3, 2, "mat-cell", 27);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(22, EventsAdminComponent_div_26_div_6_mat_header_row_22_Template, 1, 0, "mat-header-row", 33);
    i0.ɵɵtemplate(23, EventsAdminComponent_div_26_div_6_mat_row_23_Template, 1, 0, "mat-row", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var day_r27 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(day_r27.day);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("dataSource", day_r27.shifts);
    i0.ɵɵadvance(19);
    i0.ɵɵproperty("matHeaderRowDef", i0.ɵɵpureFunction0(4, _c2));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(5, _c2));
} }
function EventsAdminComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "mat-card", 21);
    i0.ɵɵelementStart(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, EventsAdminComponent_div_26_div_6_Template, 24, 6, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r10.selectedEvent.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r10.selectedEvent.description);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r10.getShiftsByDay(ctx_r10.selectedEvent.workPackages));
} }
function EventsAdminComponent_button_27_Template(rf, ctx) { if (rf & 1) {
    var _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39);
    i0.ɵɵlistener("click", function EventsAdminComponent_button_27_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r57); var ctx_r56 = i0.ɵɵnextContext(); return ctx_r56.addEvent(); });
    i0.ɵɵelementStart(1, "mat-icon", 40);
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
var EventsAdminComponent = /** @class */ (function () {
    function EventsAdminComponent(dataModel, common, log, dialog, deviceService, authService) {
        this.dataModel = dataModel;
        this.common = common;
        this.log = log;
        this.dialog = dialog;
        this.deviceService = deviceService;
        this.authService = authService;
        this.currentEvents = [];
        this.pastEvents = [];
        this.allEvents = [];
        this.users = [];
        this.accountingYear = undefined;
        this.viewMode = EventViewMode.Admin;
        this.enumViewMode = EventViewMode;
        this.eventControl = new FormControl();
        this.hideNames = false;
        this.timeframeOptions = [
            { label: '1 Monat', value: 1 },
            { label: '3 Monate', value: 3 },
            { label: '6 Monate', value: 6 },
            { label: '1 Jahr', value: 12 },
            { label: '2 Jahre', value: 24 },
        ];
        this.selectedTimeframe = 1;
        if (this.deviceService.isMobile()) {
            this.viewMode = EventViewMode.SimplifiedAdmin;
        }
    }
    EventsAdminComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadEvents();
        this.loadAccountingYear();
        this.loadUsers();
        //slection dropdown for shift overview
        this.eventControl.valueChanges.subscribe(function (value) {
            _this.selectedEvent = _this.allEvents.find(function (event) { return event.id === value; });
        });
    };
    //Load events
    EventsAdminComponent.prototype.loadEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var today, queryDate, allEventsLoaded, wpLoaded;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        today = new Date();
                        this.pastEvents = [];
                        this.currentEvents = [];
                        queryDate = new Date();
                        queryDate.setMonth(queryDate.getMonth() - this.selectedTimeframe);
                        return [4 /*yield*/, this.dataModel.getEventsWithSubData(false, false, true, true, false, "", "", "==", false)];
                    case 1:
                        allEventsLoaded = _a.sent();
                        if (!allEventsLoaded.result) {
                            this.common.showErrorToast('Alle events konnten nicht geladen werden');
                            this.log.error(allEventsLoaded.errorMessage);
                        }
                        else {
                            this.allEvents = allEventsLoaded.data;
                        }
                        return [4 /*yield*/, this.dataModel.getEventsWithSubData(false, false, true, true, true, Properties.Start, queryDate, ">=", false)];
                    case 2:
                        wpLoaded = _a.sent();
                        if (!wpLoaded.result) {
                            this.common.showErrorToast('Timeframed events konnten nicht geladen werden');
                            this.log.error(wpLoaded.errorMessage);
                        }
                        else {
                            // Filter
                            wpLoaded.data.forEach(function (element) {
                                var start = new Date(element.start.seconds * 1000);
                                var end = new Date(element.end.seconds * 1000);
                                //past
                                if (today > end) {
                                    _this.pastEvents.push(element);
                                }
                                //current
                                else if (today < start) {
                                    _this.currentEvents.push(element);
                                }
                            });
                            // Sort: approaching events first
                            this.currentEvents.sort(function (a, b) { return a.start.seconds - b.start.seconds; });
                            this.pastEvents.sort(function (a, b) { return b.end.seconds - a.end.seconds; });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    //Loads all user
    EventsAdminComponent.prototype.loadUsers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.common.loadAllUsers(function (res, allUsersData, options) {
                    if (res) {
                        _this.users = allUsersData;
                        _this.userOptions = options;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    //loads the current accounting year
    EventsAdminComponent.prototype.loadAccountingYear = function () {
        var _this = this;
        this.dataModel.loadCurrentAccountingYear().then(function (fulfilled) {
            _this.accountingYear = fulfilled;
        }, function (rejectMsg) {
            _this.common.showErrorToast('Konnte Daten des Abrechnungsjahr nicht laden');
            _this.log.error(rejectMsg, EventsAdminComponent.name);
        });
    };
    //Gets the state of this event: not started, running, past
    EventsAdminComponent.prototype.getRunningState = function (event) {
        return this.common.getRunningState(event);
    };
    EventsAdminComponent.prototype.shiftIsPassed = function (event) {
        return this.common.getRunningState(event) == EventState.Past;
    };
    //Opens a dialog to add an event
    EventsAdminComponent.prototype.addEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.accountingYear == undefined) {
                    this.common.showErrorToast('Daten zum Abrechnungsjahr nicht geladen');
                    return [2 /*return*/];
                }
                data = {
                    result: 0,
                    allUserData: this.users,
                    userOptions: this.userOptions,
                    idAccountingYear: this.accountingYear.id,
                };
                this.dialog
                    .open(AddEventComponent, {
                    width: '550px',
                    data: data,
                })
                    .afterClosed()
                    .subscribe(function (result) {
                    if (result.result == 1) {
                        _this.loadEvents();
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    //Raised when something has change in the child component
    EventsAdminComponent.prototype.eventChanged = function (change) {
        this.loadEvents();
    };
    //Called when sub compoenent is loaded
    EventsAdminComponent.prototype.subComponentIsLoaded = function () {
    };
    //Handle swipe between tabs
    EventsAdminComponent.prototype.swipe = function (e, when) {
        var coord = [
            e.changedTouches[0].clientX,
            e.changedTouches[0].clientY,
        ];
        var time = new Date().getTime();
        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
        }
        else if (when === 'end') {
            var direction = [
                coord[0] - this.swipeCoord[0],
                coord[1] - this.swipeCoord[1],
            ];
            var duration = time - this.swipeTime;
            if (duration < 1000 && //
                Math.abs(direction[0]) > 30 && // Long enough
                Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
                if (this.selectedTab == undefined)
                    this.selectedTab = 0;
                // Horizontal enough
                var swipe = direction[0] < 0 ? 'next' : 'previous';
                console.info(swipe);
                if (swipe === 'next') {
                    var isFirst = this.selectedTab === 0;
                    if (this.selectedTab <= 3) {
                        this.selectedTab = isFirst ? 1 : this.selectedTab + 1;
                    }
                    console.log('Swipe left — INDEX: ' + this.selectedTab);
                }
                else if (swipe === 'previous') {
                    var isLast = this.selectedTab === 4;
                    if (this.selectedTab >= 1) {
                        this.selectedTab = this.selectedTab - 1;
                    }
                    console.log('Swipe right — INDEX: ' + this.selectedTab);
                }
            }
        }
    };
    /**
     * Checks if the current user is an events admin.
     * @returns {boolean} Returns true if the user is an events admin, false otherwise.
     */
    EventsAdminComponent.prototype.onlyEventsAdmin = function () {
        return this.authService.isEventsAdmin;
    };
    EventsAdminComponent.prototype.getShiftsByDay = function (workPackages) {
        var groupedByDay = groupBy(workPackages, function (wp) { return wp.start.toDate().toLocaleDateString(); });
        return Object.keys(groupedByDay).sort(function (a, b) { return new Date(a).getTime() - new Date(b).getTime(); }).map(function (day) {
            var date = new Date(day);
            var dayName = date.toLocaleDateString('de-DE', { weekday: 'long' });
            var shifts = groupedByDay[day];
            //sort by shift names
            shifts.sort(function (a, b) {
                return a[Properties.Type] < b[Properties.Type] ? -1 : 1;
            });
            return {
                day: dayName,
                shifts: shifts
            };
        });
    };
    EventsAdminComponent.prototype.onTimeframeChange = function () {
        this.loadEvents();
    };
    EventsAdminComponent.prototype.trackByEventId = function (index, event) {
        return event.id;
    };
    EventsAdminComponent.prototype.onChangeShowNames = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (event) {
                    this.hideNames = event.checked;
                }
                return [2 /*return*/];
            });
        });
    };
    EventsAdminComponent.prototype.calcFreePlaces = function (shift) {
        var _a;
        if (this.common.isConstructionOrDismantling(shift)) {
            return "Keine Begrenzung";
        }
        var res = shift.minParticipants - ((_a = shift.participants) === null || _a === void 0 ? void 0 : _a.length);
        if (res <= 0)
            return "Keine freien Plätze";
        return res.toString();
    };
    EventsAdminComponent.ɵfac = function EventsAdminComponent_Factory(t) { return new (t || EventsAdminComponent)(i0.ɵɵdirectiveInject(i1.DataModelService), i0.ɵɵdirectiveInject(i2.CommonFunctionsService), i0.ɵɵdirectiveInject(i3.LogService), i0.ɵɵdirectiveInject(i4.MatDialog), i0.ɵɵdirectiveInject(i5.DeviceDetectorService), i0.ɵɵdirectiveInject(i6.AuthService)); };
    EventsAdminComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EventsAdminComponent, selectors: [["app-events-admin"]], viewQuery: function EventsAdminComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatAccordion, 1);
        } if (rf & 2) {
            var _t = void 0;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t.first);
        } }, decls: 28, vars: 14, consts: [[3, "touchstart", "touchend"], [1, "timeframe-selector"], ["appearance", "fill"], [3, "value", "valueChange", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["mat-stretch-tabs", "true", "mat-align-tabs", "center", 3, "selectedIndex", "selectedIndexChange"], ["mat-tab-label", ""], ["class", "event-view", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "no-events-text", 4, "ngIf"], ["fxLayout", "column", "fxLayoutAlign", "center center", "fxLayoutGap", "20px"], ["appearance", "fill", 2, "padding-top", "20px", "padding-left", "5%", "padding-right", "5%", "padding-bottom", "20px"], [3, "formControl"], ["class", "footer-icon", "style", "padding-left: 5%;", "matTooltip", "Namen ausblenden", "color", "primary", 3, "checked", "change", 4, "ngIf"], ["fxLayout", "column", "fxLayoutAlign", "start stretch", "fxLayoutGap", "20px", "style", "padding: 2%", 4, "ngIf"], ["mat-fab", "", "style", "z-index: 9998 !important", "class", "history-btn", "color", "primary", "aria-label", "Event hinzuf\u00FCgen", 3, "click", 4, "ngIf"], [3, "value"], [1, "event-view"], [3, "data", "users", "userOptions", "accountingYear", "viewMode", "collapsed", "componentChanged", "componentLoaded"], [1, "no-events-text"], ["matTooltip", "Namen ausblenden", "color", "primary", 1, "footer-icon", 2, "padding-left", "5%", 3, "checked", "change"], ["fxLayout", "column", "fxLayoutAlign", "start stretch", "fxLayoutGap", "20px", 2, "padding", "2%"], [2, "text-align", "center", "background-color", "lightgrey", "margin-bottom", "20px"], ["fxLayout", "column", "fxLayoutGap", "10px", 4, "ngFor", "ngForOf"], ["fxLayout", "column", "fxLayoutGap", "10px"], ["mat-table", "", 1, "mat-elevation-z8", "responsive-table", 3, "dataSource"], ["matColumnDef", "name"], [4, "matHeaderCellDef"], [4, "matCellDef"], ["matColumnDef", "responsiblePerson"], ["matColumnDef", "start"], ["matColumnDef", "end"], ["matColumnDef", "freePlaces"], ["matColumnDef", "participants"], [4, "matHeaderRowDef"], [4, "matRowDef", "matRowDefColumns"], [1, "participants-container"], ["class", "participant-cell", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "participant-cell", 3, "ngClass"], [4, "ngIf"], ["mat-fab", "", "color", "primary", "aria-label", "Event hinzuf\u00FCgen", 1, "history-btn", 2, "z-index", "9998 !important", 3, "click"], [1, "history-icon"]], template: function EventsAdminComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("touchstart", function EventsAdminComponent_Template_div_touchstart_0_listener($event) { return ctx.swipe($event, "start"); })("touchend", function EventsAdminComponent_Template_div_touchend_0_listener($event) { return ctx.swipe($event, "end"); });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵelementStart(2, "mat-form-field", 2);
            i0.ɵɵelementStart(3, "mat-label");
            i0.ɵɵtext(4, "Zeitraum");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "mat-select", 3);
            i0.ɵɵlistener("valueChange", function EventsAdminComponent_Template_mat_select_valueChange_5_listener($event) { return ctx.selectedTimeframe = $event; })("selectionChange", function EventsAdminComponent_Template_mat_select_selectionChange_5_listener() { return ctx.onTimeframeChange(); });
            i0.ɵɵtemplate(6, EventsAdminComponent_mat_option_6_Template, 2, 2, "mat-option", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "mat-tab-group", 5);
            i0.ɵɵlistener("selectedIndexChange", function EventsAdminComponent_Template_mat_tab_group_selectedIndexChange_7_listener($event) { return ctx.selectedTab = $event; });
            i0.ɵɵelementStart(8, "mat-tab");
            i0.ɵɵtemplate(9, EventsAdminComponent_ng_template_9_Template, 1, 0, "ng-template", 6);
            i0.ɵɵtemplate(10, EventsAdminComponent_div_10_Template, 2, 6, "div", 7);
            i0.ɵɵtemplate(11, EventsAdminComponent_div_11_Template, 3, 0, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "mat-tab");
            i0.ɵɵtemplate(13, EventsAdminComponent_ng_template_13_Template, 1, 0, "ng-template", 6);
            i0.ɵɵtemplate(14, EventsAdminComponent_div_14_Template, 2, 6, "div", 7);
            i0.ɵɵtemplate(15, EventsAdminComponent_div_15_Template, 3, 0, "div", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "mat-tab");
            i0.ɵɵtemplate(17, EventsAdminComponent_ng_template_17_Template, 1, 0, "ng-template", 6);
            i0.ɵɵelementStart(18, "div", 9);
            i0.ɵɵelementStart(19, "mat-form-field", 10);
            i0.ɵɵelementStart(20, "mat-label");
            i0.ɵɵtext(21, "Event ausw\u00E4hlen");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "mat-select", 11);
            i0.ɵɵtemplate(23, EventsAdminComponent_mat_option_23_Template, 2, 3, "mat-option", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, EventsAdminComponent_mat_slide_toggle_24_Template, 2, 1, "mat-slide-toggle", 12);
            i0.ɵɵelement(25, "hr");
            i0.ɵɵtemplate(26, EventsAdminComponent_div_26_Template, 7, 3, "div", 13);
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(27, EventsAdminComponent_button_27_Template, 3, 0, "button", 14);
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("value", ctx.selectedTimeframe);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.timeframeOptions);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("selectedIndex", ctx.selectedTab);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.currentEvents)("ngForTrackBy", ctx.trackByEventId);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.currentEvents == null ? null : ctx.currentEvents.length) == 0);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.pastEvents)("ngForTrackBy", ctx.trackByEventId);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", (ctx.pastEvents == null ? null : ctx.pastEvents.length) == 0);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("formControl", ctx.eventControl);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngForOf", ctx.allEvents);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.selectedEvent);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.selectedEvent);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.viewMode == ctx.enumViewMode.Admin && ctx.onlyEventsAdmin());
        } }, directives: [i7.MatFormField, i7.MatLabel, i8.MatSelect, i9.NgForOf, i10.MatTabGroup, i10.MatTab, i10.MatTabLabel, i9.NgIf, i11.NgControlStatus, i11.FormControlDirective, i12.MatOption, i13.EventViewComponent, i14.MatSlideToggle, i15.MatTooltip, i16.MatCard, i17.MatTable, i17.MatColumnDef, i17.MatHeaderCellDef, i17.MatCellDef, i17.MatHeaderRowDef, i17.MatRowDef, i17.MatHeaderCell, i17.MatCell, i9.NgClass, i17.MatHeaderRow, i17.MatRow, i18.MatButton, i19.MatIcon], pipes: [i9.DatePipe], styles: [".timeframe-selector[_ngcontent-%COMP%] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 10px 5% 0 5%;\n}\n\n.timeframe-selector[_ngcontent-%COMP%]   mat-form-field[_ngcontent-%COMP%] {\n  width: 200px;\n}\n\n.event-view[_ngcontent-%COMP%] {\n  margin: 2% 2% 5% 2%;\n}\n\n@media screen and (max-width: 700px) {\n  .event-view[_ngcontent-%COMP%] {\n    margin: 0;\n  }\n}\n\n.no-events-text[_ngcontent-%COMP%] {\n  margin: auto;\n  width: 75%;\n  padding: 10px;\n  margin-top: 40%;\n  text-align: center;\n  padding-bottom: 80%;\n}\n\n\n\n.occupied[_ngcontent-%COMP%] {\n  background-color: green;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n}\n\n.empty[_ngcontent-%COMP%] {\n  background-color: red;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n}\n\ntable[_ngcontent-%COMP%] {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.responsive-table[_ngcontent-%COMP%] {\n  overflow-x: auto;\n}\n\n.participants-container[_ngcontent-%COMP%] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 10px;\n}\n\n.participant-cell[_ngcontent-%COMP%] {\n  padding: 10px;\n  border: 1px solid #ccc;\n  text-align: center;\n  width: 120px; \n  height: 50px; \n  box-sizing: border-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  word-break: break-word; \n}\n\n@media (max-width: 768px) {\n  .participant-cell[_ngcontent-%COMP%] {\n    width: 80px;\n    font-size: 0.8em;\n  }\n\n  mat-form-field[_ngcontent-%COMP%] {\n    width: 100%;\n  }\n}\n\n.mat-column-name[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 15% !important;\n      flex: 0 0 15% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-responsiblePerson[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 15% !important;\n      flex: 0 0 15% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-start[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 5% !important;\n      flex: 0 0 5% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-end[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 5% !important;\n      flex: 0 0 5% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-freePlaces[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 10% !important;\n      flex: 0 0 10% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n\n.mat-column-participants[_ngcontent-%COMP%] {\n  word-wrap: break-word !important;\n  white-space: unset !important;\n  -ms-flex: 0 0 50% !important;\n      flex: 0 0 50% !important;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -webkit-hyphens: auto;\n          hyphens: auto;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */"] });
    return EventsAdminComponent;
}());
export { EventsAdminComponent };
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EventsAdminComponent, [{
        type: Component,
        args: [{
                selector: 'app-events-admin',
                templateUrl: './events-admin.component.html',
                styleUrls: ['./events-admin.component.css'],
            }]
    }], function () { return [{ type: i1.DataModelService }, { type: i2.CommonFunctionsService }, { type: i3.LogService }, { type: i4.MatDialog }, { type: i5.DeviceDetectorService }, { type: i6.AuthService }]; }, { accordion: [{
            type: ViewChild,
            args: [MatAccordion]
        }] }); })();
//# sourceMappingURL=events-admin.component.js.map